import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["imageUrl", "name", "description", "jobTitle", "organisationName", "organisationUrl", "onClick"];
let _ = t => t,
  _t;
import I18n from 'I18n';
import UIImage from 'UIComponents/image/UIImage';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { css, mediaQuery, useMediaQuery } from '../../utils/Styling';
import { H4, H7 } from 'UIComponents/elements/headings';
import UIMediaRight from 'UIComponents/layout/UIMediaRight';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useState } from 'react';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InstructorImage = styled(UIImage).withConfig({
  displayName: "ACInstructorCard__InstructorImage",
  componentId: "sc-1wj4vd-0"
})(["object-fit:cover;"]);
const InstructorCard = styled.div.withConfig({
  displayName: "ACInstructorCard__InstructorCard",
  componentId: "sc-1wj4vd-1"
})(["", ""], mediaQuery('mobile', css(_t || (_t = _`
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    `))));
const ACInstructorCard = _ref => {
  let {
      imageUrl,
      name,
      description,
      jobTitle,
      organisationName,
      organisationUrl,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  const [isExpanded, setIsExpanded] = useState(false);
  const NameComponent = isMobile ? H7 : H4;
  return /*#__PURE__*/_jsxs(InstructorCard, Object.assign({
    onClick: () => setIsExpanded(bool => !bool)
  }, props, {
    children: [/*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: /*#__PURE__*/_jsx(InstructorImage, {
          alt: I18n.text('academyCommon.instructor.imageAlt', {
            instructorName: name
          }),
          height: 60,
          loading: "lazy",
          responsive: false,
          shape: "rounded",
          src: imageUrl,
          width: 60
        })
      }), /*#__PURE__*/_jsxs(UIMediaBody, {
        children: [/*#__PURE__*/_jsx(NameComponent, {
          className: "m-bottom-0",
          children: name
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: jobTitle
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: organisationUrl && organisationName ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: organisationUrl,
            onClick: onClick,
            children: organisationName
          }) : organisationName
        })]
      }), isMobile && /*#__PURE__*/_jsx(UIMediaRight, {
        children: /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          justify: "end",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: isExpanded ? 'up' : 'down',
            style: {
              position: 'relative',
              top: '1px'
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: !isMobile || isExpanded,
      children: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-0 m-top-4",
        children: /*#__PURE__*/_jsx(UITruncateMultiline, {
          maxChars: 500,
          text: description || ''
        })
      })
    })]
  }));
};
export default ACInstructorCard;